import React from "react";
import { getStories } from "../../api";
import axios from "axios";
import severUrl from "../../api";

class Story extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            stories: []
        };
    }

    componentDidMount() {
        var bodyFormData = new FormData();
        bodyFormData.append("topic_id", 8);
        axios.post(severUrl + "blog/post/story/", bodyFormData).then((response) => {
            this.setState({ stories: response.data })
            // console.log(response)
        })
    }

    render() {
        return (
            <>
                <p></p>
                <p>Many technical paritioner choose other job like photographer or Photo editor for 2nd job</p>
                <p>In this series, I will write about others topic about my lives</p>
                <p>I hope writting well help my english level will push up my English competency. Also help me relax</p>
                <p>These topics are not trueky technical so please swith to other tab if you don't like</p>
                {
                    this.state.stories.map((item, i) => {
                        return (
                            <p>
                                <a
                                    style={
                                        {
                                            fontSize: "22px",
                                            fontWeight: "0.4"
                                        }
                                    }
                                    href={`/${item.slug}`}>{item.title}</a>
                            </p>
                        );
                    })
                }
            </>
        );
    }
}

export default Story;
